import { render } from "./FormularioContato.vue?vue&type=template&id=53a19717"
import script from "./FormularioContato.vue?vue&type=script&lang=js"
export * from "./FormularioContato.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__